import { NumberValueFormatter } from '@gogame/intl-ts';

import TickText from '../../TickText';

export const YAxisDecimalTick = ({ payload, ...props }) => {
  return (
    <TickText {...props}>
      <NumberValueFormatter.Decimal value={payload.value} />
    </TickText>
  );
};
